/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_MemoriesInputs */

const en_video_memories = /** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Memories`)
};

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const es_video_memories = en_video_memories;

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const fr_video_memories = en_video_memories;

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const de_video_memories = en_video_memories;

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const ja_video_memories = en_video_memories;

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const zh_video_memories = en_video_memories;

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const ar_video_memories = en_video_memories;

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const id_video_memories = en_video_memories;

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const it_video_memories = en_video_memories;

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const ru_video_memories = en_video_memories;

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const pt_video_memories = en_video_memories;

/** @type {(inputs: Video_MemoriesInputs) => LocalizedString} */
const ko_video_memories = en_video_memories;

/**
* | output |
* | --- |
* | "Video Memories" |
*
* @param {Video_MemoriesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const video_memories = /** @type {((inputs?: Video_MemoriesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_MemoriesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_video_memories(inputs)
	if (locale === "es") return es_video_memories(inputs)
	if (locale === "fr") return fr_video_memories(inputs)
	if (locale === "de") return de_video_memories(inputs)
	if (locale === "ja") return ja_video_memories(inputs)
	if (locale === "zh") return zh_video_memories(inputs)
	if (locale === "ar") return ar_video_memories(inputs)
	if (locale === "id") return id_video_memories(inputs)
	if (locale === "it") return it_video_memories(inputs)
	if (locale === "ru") return ru_video_memories(inputs)
	if (locale === "pt") return pt_video_memories(inputs)
	return ko_video_memories(inputs)
});